module.exports = __webpack_public_path__ + "img/twitter.1.2fa4bd8f.svg";